module.exports = __webpack_public_path__ + "static/media/banner.fc127bce.jpg";